import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#2661FF',
        accent: '#ce93d8',
        secondary: '#424242',
        error: '#E71A28',
        info: '#2196F3',
        success: '#0FCB93',
        warning: '#FAAA10'
      }
    }
  },
  icons: {
    iconfont: 'md'
  }
})
